import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';

import { CFLogo } from './CFLogo';

import { ArrowBackIcon } from '~assets';
import { LOGIN_PATH } from '~configs';

type NavBarProps = {
  LeftComponent?: React.ReactNode;
  MiddleComponent?: React.ReactNode;
  RightComponent?: React.ReactNode;
};

export const NavBar: React.FC<NavBarProps> = ({
  LeftComponent,
  MiddleComponent,
  RightComponent,
}) => {
  return (
    <Grid
      container
      right={0}
      left={0}
      position="fixed"
      paddingX={1}
      minHeight="64px"
      justifyContent="space-between"
      alignItems="center"
      zIndex={100}
      bgcolor="background.paper"
    >
      {/* Left Component */}
      <Grid item xs={2} container justifyContent="center" alignItems="center">
        {LeftComponent !== undefined ? LeftComponent : <DefaultLeftComponent />}
      </Grid>

      {/* Middle Component */}
      <Grid item xs={8} container justifyContent="center" alignItems="center">
        {MiddleComponent !== undefined ? (
          MiddleComponent
        ) : (
          <DefaultMiddleComponent />
        )}
      </Grid>

      {/* Right Component */}
      <Grid item xs={2} container justifyContent="center" alignItems="center">
        {RightComponent !== undefined ? (
          RightComponent
        ) : (
          <DefaultRightComponent />
        )}
      </Grid>
    </Grid>
  );
};

// Default Left Component - Back Button
const DefaultLeftComponent = () => {
  const navigate = useNavigate();
  return (
    <IconButton size="large" onClick={() => navigate(LOGIN_PATH)}>
      <ArrowBackIcon />
    </IconButton>
  );
};

// Default Middle Component - Logo
const DefaultMiddleComponent = () => <CFLogo width={200} />;

// Default Right Component - Logout Button
const DefaultRightComponent = () => {
  const navigate = useNavigate();
  return (
    <IconButton size="large" onClick={() => navigate(LOGIN_PATH)}>
      <Logout />
    </IconButton>
  );
};
